import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabase } from "@/lib/supabase";
import { resolvePostAuthRedirect } from "@/lib/auth";

/** The app root has no page of its own: signed-in users go to their home, everyone else to sign in. */
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) throw redirect({ to: "/login" });
    throw redirect({ to: await resolvePostAuthRedirect() });
  },
});
